import React from 'react'

const styles = require('./timer.module.scss')

const SECONDS_IN_HOUR = 3600
const SECONDS_IN_MINUTE = 60

const convertSecondsToTime = (seconds: number): string => {
    let timeLeft = seconds

    const hours = Math.floor(timeLeft / SECONDS_IN_HOUR)
    timeLeft = timeLeft % SECONDS_IN_HOUR

    const minutes = Math.floor(timeLeft / SECONDS_IN_MINUTE)
    timeLeft = timeLeft % SECONDS_IN_MINUTE

    let hoursString = ''
    if (hours) {
        hoursString += `${hours}:`
    }

    const minutesString = minutes < 10 ? `0${minutes}` : minutes
    const secondsString = timeLeft < 10 ? `0${timeLeft}` : timeLeft
    return `${hoursString}${minutesString}:${secondsString}`
}

interface TimerProps {
    /** Отображаемое время в секундах */
    secondsLeft: number
    /** Не передавать анонимную функцию, иначе будут лишние ререндеры, которые будут задерживать таймер */
    countdownCallback?: () => void
    showBrackets?: boolean
}

const TimerInner: React.FC<TimerProps> = props => {
    const { showBrackets, secondsLeft, countdownCallback } = props
    const [seconds, setSeconds] = React.useState(secondsLeft)

    React.useEffect(() => {
        const timer = setTimeout(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1)
            } else {
                if (countdownCallback) {
                    countdownCallback()
                }
            }
        }, 1000);

        return () => clearTimeout(timer);
    })

    return (
        <span className={styles.timer}>{showBrackets && '('}{convertSecondsToTime(seconds)}{showBrackets && ')'}</span>
    )
}

export const Timer = React.memo(TimerInner)
